import api from '@/api/api';

import { ApiTextChat } from '.';
import { AxiosResponse } from 'axios';
import { IResponseData } from '@/models/common';
import { ITextMessage } from '@/models/textChat';
import getApiResponse from '@/api/apiResponse';
const TextChatService = {
  async getLastMessage(roomName: string) {
    const params = {
      roomName,
    };
    const res: AxiosResponse<IResponseData<ITextMessage>> = await api.get(ApiTextChat.GET_LASTMESSAGE, {
      params,
    });
    return getApiResponse<ITextMessage>(res);
  },
};

export default TextChatService;
